import React from 'react';
import { Footer } from '../Nav/Footer/Footer';
import { NavBar } from '../Nav/NavBar/NavBar';
import { Employment } from '../Employment/Employment';


export const EmploymentHistory = () => {

    return (
        <div>
            <NavBar />
            <Employment />
            <Footer />
        </div>

    );
}